import React from "react";
import "./TableCard.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import emptyIcon from "../../assets/Icons/emptyIcon.svg";
import { formatDate } from "../../Utils/helper";
import LoadingOverlay from "../Loading/LoadingOverlay";
import shareIcon from "../../assets/Icons/shareIcon.svg";
import acceptIcon from "../../assets/Icons/accept.svg";
import rejectIcon from "../../assets/Icons/reject.svg";
import { useLocation } from "react-router-dom";
import ToggleButton from "../Button/ToggleButton";
import Cookies from "js-cookie";
import chevronblack from "../../assets/Icons/chevron-black.svg";
import { open_api_with_cookies } from "../../Utils/network";
import { convertToLocalTime } from "../../Utils/helper";

const TableCard = ({
  columns,
  data,
  totalEntries,
  currentPage,
  totalPages,
  onPageChange,
  isClickable,
  loading,
  isShowJoinButton,
  isSharable,
  onShare,
  setData,
  isCoupon,
  isRevenue,
  isLeads,
  handleClick,
  disableLocalPagination,
}) => {
  const handleToggle = async (event) => {
    const id = parseInt(event.target.id.slice(4));
    const element = currPage.find((el) => el.id === id);
    if (!element) {
      console.error("Element not found");
      return;
    }
    const isactive = !element.is_visible;
    const updatedPage = currPage.map((el) =>
      el.id === id ? { ...el, is_visible: isactive } : el
    );
    setData(updatedPage);
    try {
      await open_api_with_cookies.patch(`/coupon/dashboard/update/${id}/`, {
        is_visible: isactive,
      });
      console.log("called");
      const expertid = Cookies.get("expertID");
      const result = await open_api_with_cookies.get(
        `/coupon/dashboard/bookings/list/${expertid}/`
      );
      const updatedData = result.data.results;
      console.log(updatedData);
      setData(updatedData);
    } catch (error) {
      console.error("Error updating toggle state:", error);
    }
  };
  const entriesPerPage = 10; // Set entries per page to 10

  const entriesStart = (currentPage - 1) * entriesPerPage + 1;
  const entriesEnd = Math.min(currentPage * entriesPerPage, totalEntries);
  const currPage = disableLocalPagination
    ? data
    : data.slice(entriesStart - 1, currentPage * entriesPerPage);

  const { pathname } = useLocation();
  const route = pathname.split("/");

  return (
    <div className="table-card">
      {loading ? (
        <LoadingOverlay />
      ) : (
        <div className="table-container">
          <div className="table-header">
            {columns.map((col, index) => (
              <div key={index} className="table-header-cell">
                {col.header}
              </div>
            ))}
            {isShowJoinButton || isSharable ? (
              <div className="table-header-cell">Actions</div>
            ) : null}
          </div>

          <div className="table-body">
            {currPage.length > 0 ? (
              currPage.map((row, rowIndex) => {
                const uniqueRowKey = `${row.id || rowIndex}-${rowIndex}`;
                const rowContent = (
                  <div
                    key={uniqueRowKey}
                    className={`table-row ${isClickable ? "clickable" : ""}`}
                  >
                    {columns.map((col, colIndex) => (
                      <div
                        key={`${uniqueRowKey}-${colIndex}`}
                        className="table-cell-row"
                      >
                        {col.accessor === "status" ? (
                          <span
                            className={`status-badge ${row[
                              col.accessor
                            ]?.toLowerCase()}`}
                          >
                            {row[col.accessor]}
                          </span>
                        ) : col.accessor === "created" ||
                          col.accessor === "from_date" ||
                          col.accessor === "to_date" ||
                          col.accessor == "created_at" ? (
                          formatDate(row[col.accessor])
                        ) : col.accessor === "active" ? (
                          <span>
                            <img
                              src={row[col.accessor] ? acceptIcon : rejectIcon}
                              alt={row[col.accessor] ? "Active" : "Inactive"}
                            />
                          </span>
                        ) : col.accessor === "discount" ? (
                          row.discount_type === "Amount" ? (
                            `₹${row.discount || 0} / $${row.discount_usd || 0}`
                          ) : row.discount_type === "Percentage" ? (
                            `${row.discount}%`
                          ) : (
                            `${row.discount || 0}% up to ₹${
                              row.upto_amt || 0
                            }/$${row.upto_amt_usd || 0}`
                          )
                        ) : col.accessor === "is_visible" ? (
                          <button className="share-button">
                            <ToggleButton
                              isToggled={row[col.accessor]}
                              onToggle={handleToggle}
                              id={`row-${row.id}`}
                            />
                          </button>
                        ) : col.accessor === "details" ? (
                          <p
                            // to={`dashboard/details/${row.id}/`}
                            onClick={handleClick}
                            key={`link-${uniqueRowKey}`}
                          >
                            <img src={chevronblack} alt="Share" id={row.id} />
                          </p>
                        ) : col.accessor === "created_time" ? (
                          convertToLocalTime(row.created_at)
                        ) : col.accessor == "payment_status" ? (
                          <p
                            className={`status-badge ${
                              row.payment_status === "Paid" ? "paid" : "failed"
                            }`}
                          >
                            {row[col.accessor]}
                          </p>
                        ) : col.accessor == "total_amt" ||
                          col.accessor == "expert_earning" ? (
                          row[col.accessor] != null ? (
                            row.currency === "INR" ? (
                              `₹${row[col.accessor]}`
                            ) : (
                              `$${row[col.accessor]}`
                            )
                          ) : (
                            ""
                          )
                        ) : col.accessor == "batch_name" ? (
                          <p>{row[col.accessor]}</p>
                        ) : (
                          row[col.accessor]
                        )}
                      </div>
                    ))}
                    {isShowJoinButton ? (
                      <div className="table-cell join-button-cell">
                        <button className="join-button">Join</button>
                      </div>
                    ) : null}
                    {isSharable ? (
                      <div className="table-cell share-button-cell">
                        <button
                          onClick={() => {
                            onShare(row);
                          }}
                          className="share-button"
                        >
                          <img src={shareIcon} alt="Share" />
                        </button>
                      </div>
                    ) : null}
                  </div>
                );

                return isClickable ? (
                  !isCoupon ? (
                    <p
                      // to={`/${route[1]}/details/${row.id}`}
                      id={row.id}
                      onClick={handleClick}
                      key={`link-${uniqueRowKey}`}
                      className={`table-row-link ${
                        isClickable ? "clickable" : ""
                      }`}
                    >
                      {rowContent}
                    </p>
                  ) : (
                    <div
                      id={row.id}
                      to={`dashboard/details/${row.id}`}
                      key={`link-${uniqueRowKey}`}
                      className={`table-row-link`}
                    >
                      {rowContent}
                    </div>
                  )
                ) : (
                  <div
                    key={`link-${uniqueRowKey}`}
                    className="table-row-link-disabled"
                  >
                    {rowContent}
                  </div>
                );
              })
            ) : (
              <div className="empty-icon">
                <img src={emptyIcon} alt="No data" />
                <p>
                  No{" "}
                  {isCoupon
                    ? "coupon"
                    : isLeads
                    ? "leads"
                    : isRevenue
                    ? "revenue data "
                    : "booking"}{" "}
                  yet
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {!loading && (
        <div className="table-footer">
          <div className="table-footer-left">
            Showing {disableLocalPagination ? 1 : entriesStart} to{" "}
            {disableLocalPagination ? data.length : entriesEnd} of{" "}
            {totalEntries} entries
          </div>
          <div className="table-footer-right">
            <button
              disabled={currentPage === 1}
              onClick={() => onPageChange(currentPage - 1)}
            >
              &lt;
            </button>
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                className={currentPage === index + 1 ? "active" : ""}
                onClick={() => onPageChange(index + 1)}
              >
                {index + 1}
              </button>
            ))}
            <button
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(currentPage + 1)}
            ></button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableCard;
